import { render, staticRenderFns } from "./LoopListProd.vue?vue&type=template&id=3b366969&scoped=true"
import script from "./LoopListProd.vue?vue&type=script&lang=js"
export * from "./LoopListProd.vue?vue&type=script&lang=js"
import style0 from "./LoopListProd.vue?vue&type=style&index=0&id=3b366969&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b366969",
  null
  
)

export default component.exports